import { Button, ConfigProvider } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { SUCCESS_COLOR } from '@shared/constants/colors';

export const StepControls = ({ current, total, onNext, onPrevious, isExternal }) => {
  const hasPrevious = current > 0;
  const isLastStep = current === total - 1;

  return (
    <div
      style={isExternal ? {
        display: 'flex',
        justifyContent: 'flex-end',
        gap: 8,
      } : {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(12em, 1fr))',
        gap: 8,
      }}
    >
      {hasPrevious && <Button onClick={onPrevious}>Anterior</Button>}
      {isLastStep ? (
        isExternal ? (
          <Button
            type='primary'
            icon={<FontAwesomeIcon icon={faCheck} />}
            onClick={onNext}
          >
            Crear cotización
          </Button>
        ) : (
          <ConfigProvider
            theme={{
              components: {
                Button: {
                  colorPrimary: SUCCESS_COLOR,
                  algorithm: true,
                },
              },
            }}
          >
            <Button
              type='primary'
              icon={<FontAwesomeIcon icon={faCheck} />}
              onClick={onNext}
            >
              Generar cotizaciones
            </Button>
          </ConfigProvider>
        )
      ) : (
        <Button
          type='primary'
          onClick={onNext}
        >
          Siguiente
        </Button>
      )}
    </div>
  );
};
